<template>  
 <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
<!-- <v-tour name="myTour" :steps="steps">
  <template slot-scope="tour">
    <transition name="fade">
      <v-step
        v-if="tour.steps[tour.currentStep]"
        :key="tour.currentStep"
        :step="tour.steps[tour.currentStep]"
        :previous-step="tour.previousStep"
        :next-step="tour.nextStep"
        :stop="tour.stop"
        :is-first="tour.isFirst"
        :is-last="tour.isLast"
        :labels="tour.labels"
      >
        <template v-if="tour.currentStep === 1">
          <div slot="actions">
            <button @click="tour.previousStep" class="btn btn-sm btn-success mr-2">Previous</button>
            <button @click="tour.nextStep" class="btn btn-sm btn-success">Next</button>
          </div>
        </template>
         <template v-if="tour.currentStep === 2">
          <div slot="actions">
            <button @click="tour.previousStep" class="btn btn-sm btn-success mr-2">Previous</button>
            <button @click="tour.nextStep" class="btn btn-sm btn-success">Next</button>
          </div>
        </template>
         <template v-if="tour.currentStep === 3">
          <div slot="actions">
            <button @click="tour.stop" class="btn btn-sm btn-success">Finish</button>
          </div>
        </template>
        <template v-if="tour.currentStep === 0">
          <div slot="actions">
            <button @click="tour.nextStep" class="btn btn-sm btn-success">Next</button>
          </div>
        </template>
        
      </v-step>
    </transition>
  </template>
</v-tour> -->
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">
                <slot name="left"></slot>
            </h1>
          </div><!-- /.col -->
        
          <div class="col-sm-6">
               <slot name="right"></slot>
          </div><!-- /.col -->

        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->


    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
            <slot/>
        </div>
        <!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>


<script>
  export default {
    name: 'my-tour',
    data () {
      return {

          steps: [
          {
            target: '.step-1',  // We're using document.querySelector() under the hood
            content: `<strong>Add tracks to your radio</strong>! <br>Start by adding some music <br> in your media file`
          },
          {
            target: '.step-2',
            content: 'Upload mp3 audio files and<br> add to a playlist'
          },
          {
            target: '.step-3',
            content: 'Select the uploaded audio(s),<br> add it to a playlist then save<br> ',
            params: {
              placement: 'left'
            }
          },

           {
            target: '.step-4',
            content: 'Start your radio!',
           
            
          }
        ]
      }
    },
    mounted: function () {

      // setTimeout(() => {
      //   if (this.station_info.tour_off == false) {
      //     this.$tours['myTour'].start()
      //   }
      // }, 1000);
      
    }
  }
</script>
